import { useQuery } from 'react-query';
import { getWorkAgreements } from 'RestAPIs/employees/leave-requests';

type EmployeeWorkAgreementProps = {
  startDate: Date;
  endDate: Date;
  employeeId: number;
};

const useGetEmployeeWorkAgreements = ({
  startDate,
  endDate,
  employeeId
}: EmployeeWorkAgreementProps) => {
  const { data, isFetching, isError, refetch } = useQuery(
    ['employeeWorkAgreements', employeeId, startDate, endDate],
    async () => {
      const { data } = await getWorkAgreements({
        startDate,
        endDate,
        employeeId
      });
      return data;
    },
    {
      enabled: !!startDate && !!endDate && !!employeeId
    }
  );
  return { data, isFetching, isError, refetch };
};

export default useGetEmployeeWorkAgreements;
